/**
 * Trạng thái trong-phiên cho interstitial. Cố ý giữ trong bộ nhớ (không
 * localStorage) vì "phiên" ở đây nghĩa là lần tải trang hiện tại.
 *
 * Lý do tồn tại: Google hạ hạng mobile với interstitial hiện ngay khi người dùng
 * vào từ kết quả tìm kiếm. Nên interstitial chỉ được phép bắn sau khi người dùng
 * đã thực sự dùng trang — hoàn thành một việc, hoặc chuyển trang vài lần.
 */

export type AffiliateCompletionEvent =
  | "practice_finished"
  | "grade_calculated";

interface AffiliateSession {
  navigations: number;
  completionEvent: AffiliateCompletionEvent | null;
}

const session: AffiliateSession = {
  navigations: 0,
  completionEvent: null,
};

export const markAffiliateNavigation = (): void => {
  session.navigations += 1;
};

export const getAffiliateNavigationCount = (): number => session.navigations;

export const markAffiliateCompletionEvent = (
  event: AffiliateCompletionEvent
): void => {
  session.completionEvent = event;
};

export const getAffiliateCompletionEvent =
  (): AffiliateCompletionEvent | null => session.completionEvent;

export const clearAffiliateCompletionEvent = (): void => {
  session.completionEvent = null;
};
